import { FunctionComponent, PropsWithChildren } from 'react'

import { ConditionalOptions, FormConfig } from '../../../state/configuration'
import useConditions from '../conditions'

type FormConditionalProps = PropsWithChildren<{
  config: FormConfig
  item: FormConfig[0]
  options: Partial<ConditionalOptions>
}>

export const FormConditional: FunctionComponent<FormConditionalProps> = ({
  children,
  config,
  options,
  item: { conditional },
}) => {
  const conditions = useConditions(config, options)

  const visible =
    conditional?.operator === 'some'
      ? conditional?.conditions.some(conditions) ?? true
      : conditional?.conditions.every(conditions) ?? true

  return visible ? children : null
}
